document.addEventListener('DOMContentLoaded', () => {
  // Desktop Search
  const inputDesktop = document.querySelector('[js-search-form-desktop]');
  const buttonELDesktop = document.querySelector('[js-search-form-btn-desktop]');
  const radioButtons = document.querySelectorAll('input[name="site-section"]');

  const getSelectedSection = () => {
    let selected = 'allsite'; // default
    radioButtons.forEach((radio) => {
      if (radio.checked) selected = radio.value;
    });
    return selected;
  };

  const triggerSearch = (inputElement) => {
    const query = inputElement.value.trim();
    if (!query) return;

    const selectedSection = getSelectedSection();
    window.location.href = buildSearchUrl(query, selectedSection);
  }

  const buildSearchUrl = (query, section) => {
    switch (section) {
      case 'journal':
        return `/search?q=${encodeURIComponent(query)}&type=article`;
      case 'shop':
        return `/search?q=${encodeURIComponent(query)}&type=product`;
      default:
        return `/search?q=${encodeURIComponent(query)}`;
    }
  };

  triggerSearch(inputDesktop);

  if (buttonELDesktop) {
    buttonELDesktop.addEventListener('click', (e) => {
      e.preventDefault();
      triggerSearch(inputDesktop);
    });

    inputDesktop.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        triggerSearch(inputDesktop);
      }
    });
  }

  // Mobile Search
  const input = document.querySelector('[js-search-form]');
  const buttonEL = document.querySelector('[js-search-form-btn]');

  if (buttonEL) {
    buttonEL.addEventListener('click', (e) => {
      e.preventDefault();
      triggerSearch(input);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        triggerSearch(input);
      }
    });
  }
});
